export default function convertDatesToYear(data) {
  return data.map((item) => {
    // Create a shallow copy of the item
    const newItem = { ...item }

    Object.keys(newItem).forEach((key) => {
      // Check if the key contains 'date' (case-insensitive)
      if (key.toLowerCase().includes('date') && newItem[key]) {
        const dateString = newItem[key]

        // Simplified conversion logic as requested
        const convertDate = (str) => {
          const date = new Date(str)
          return isNaN(date) ? str : date.getFullYear().toString()
        }

        newItem[key] = convertDate(dateString)
      }
    })

    return newItem
  })
}